// extracted by mini-css-extract-plugin
export default {"productList":"OnlineStore_productList__Jxn9s"};